import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Persistence check on mount
  useEffect(() => {
    const savedUser = localStorage.getItem('app_user');
    const savedToken = localStorage.getItem('auth_token');

    if (savedUser && savedToken) {
      setUser({ username: savedUser });
    }
    setIsLoading(false);
  }, []);

  const login = (username, token) => {
    setUser({ username });
    localStorage.setItem('app_user', username);
    if (token) {
      localStorage.setItem('auth_token', token);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('app_user');
    localStorage.removeItem('auth_token');
  };

  const isLoggedIn = !!user;

  return (
    <AuthContext.Provider value={{ user, isLoggedIn, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
